const calculateSlides = (slideTrack, slideWidth) => {
    const gap = parseInt(window.getComputedStyle(slideTrack).gap) || 0
    const items = slideTrack.querySelectorAll(`.global-simple-slider__slider-item`)?.length || 1
    return Math.ceil((slideTrack.scrollWidth - (items - 1) * gap) / slideWidth)
}

const initSlider = (entries, observer) => {
    const enteringEntries = entries.filter((entry) => entry.isIntersecting);

    enteringEntries.forEach((entry) => {
        const element = entry.target
        let slideWidth = element.getBoundingClientRect().width
        let currentSlide = 0;

        const track = element.querySelector(`.global-simple-slider__slider-track`)
        const controls = element.querySelector(`.global-simple-slider__slider-controls`);

        let slides = calculateSlides(track, slideWidth)

        const nextButton = element.querySelector(`.js-next`)
        const prevButton = element.querySelector(`.js-prev`)
        const controlLabel = element.querySelector(`.global-simple-slider__slider-control-label`);


        const updateSlider = () => {
            const gap = parseInt(window.getComputedStyle(track).gap) || 0
            track.style.transform = `translateX(${-slideWidth * currentSlide - currentSlide * gap}px)`
            nextButton.disabled = currentSlide + 1 === slides
            prevButton.disabled = currentSlide === 0
            controlLabel.innerText = (currentSlide + 1) + "/" + slides;

            if (controlLabel) {
                controlLabel.hidden = element.querySelector(`.global-simple-slider__slider-item`)?.scrollWidth < slideWidth;
                controlLabel.innerText = (currentSlide + 1) + "/" + slides;
            }

            controls.hidden = slides < 2 && controls
        }
        updateSlider()


        window.addEventListener('resize', () => {
            slideWidth = element.getBoundingClientRect().width
            slides = calculateSlides(track, slideWidth)
            currentSlide = 0
            updateSlider()
        })

        nextButton.addEventListener(`click`, () => {
            currentSlide++
            updateSlider()
        })

        prevButton.addEventListener(`click`, () => {
            currentSlide--
            updateSlider()
        })

        observer.unobserve(element)
    })
}

export const globalSimpleSlider = () => {
    const elements = document.querySelectorAll(`.global-simple-slider`)
    const observer = new IntersectionObserver(initSlider)
    elements.forEach(element => {
        observer.observe(element)
    })
}
